import {registerNode} from "@cm/graph-v2-final"
import {ImageOpInputsOrNodes} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {definition} from "@app/textures/texture-editor/operator-stack/operators/tiling/node/penalize-by-distance/definition"
import {ImageOpTilingPenalizeByDistanceHal} from "@app/textures/texture-editor/operator-stack/operators/tiling/node/penalize-by-distance/hal"
import {BasicSpecializingImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/basic-specializing-image-op-node"

@registerNode
export class ImageOpNodeTilingPenalizeByDistance extends BasicSpecializingImageOpNode<typeof definition, ImageOpTilingPenalizeByDistanceHal> {
    static nodeClass = "ImageOpNodeTilingPenalizeByDistance"
    static definition = definition

    constructor(parameters: ImageOpInputsOrNodes<typeof definition>) {
        super(ImageOpTilingPenalizeByDistanceHal, parameters)
    }
}
